import { render, staticRenderFns } from "./read.vue?vue&type=template&id=2799ebfc&"
import script from "./read.vue?vue&type=script&lang=js&"
export * from "./read.vue?vue&type=script&lang=js&"
import style1 from "./read.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports